import { Component, Input, NgZone, OnInit } from "@angular/core";
import { NavigationItem } from "../../navigation";
import { Location } from "@angular/common";
import { DattaConfig } from "src/app/config/app-config";
import { UtilityService } from "src/app/services/skyaccessconfig/utility.service";
import { LocalizationHandlerService } from "src/app/services/admin/localization/localization-handler.service";




@Component({
  selector: "app-nav-item",
  templateUrl: "./nav-item.component.html",
  styleUrls: ["./nav-item.component.scss"],
})
export class NavItemComponent implements OnInit {
  @Input() item: NavigationItem;
  public dattaConfig: any;
  isSkyAccess: boolean;

  icons = {
    MmHome: "fas fa-home",
    ShareOnFb: "fas fa-paperclip",
    ShareOnTTr: "fa fa-times",
    ShareOnInst: "feather icon-instagram",
  };
  icons2 = {
    home: "fas fa-home",
    facebook: "fas fa-paperclip",
    twitter: "fa fa-times",
    instagram: "feather icon-instagram",
  };

  constructor(
    private location: Location,
    private localizationHandler: LocalizationHandlerService,
    private utilityService: UtilityService
  ) {
    this.dattaConfig = DattaConfig.config;
  }

  ngOnInit() {
    this.isSkyAccess = this.utilityService.isSkyAccess;
  }

  getIcon(item) {
    (item);
    if (item?.ID && Object.keys(this.icons).includes(item.ID))
      return this.icons[item.ID];
    else return this.icons2[item.id];
  }

  
  translate(suffix, usePrefix?) {
    const localizationKeyPrefix = "nav";
    if (usePrefix) return this.localizationHandler.getTranslation(suffix);
    return this.localizationHandler.getTranslation(
      localizationKeyPrefix + "." + suffix
    );
  }

  closeOtherMenu(event) {
    if (this.dattaConfig["layout"] === "vertical") {
      const ele = event.target;
      if (ele !== null && ele !== undefined) {
        const parent = ele.parentElement;
        const up_parent = parent.parentElement.parentElement;
        const last_parent = up_parent.parentElement;
        const sections = document.querySelectorAll(".pcoded-hasmenu");
        for (let i = 0; i < sections.length; i++) {
          sections[i].classList.remove("active");
          sections[i].classList.remove("pcoded-trigger");
        }

        if (parent.classList.contains("pcoded-hasmenu")) {
          parent.classList.add("pcoded-trigger");
          parent.classList.add("active");
        } else if (up_parent.classList.contains("pcoded-hasmenu")) {
          up_parent.classList.add("pcoded-trigger");
          up_parent.classList.add("active");
        } else if (last_parent.classList.contains("pcoded-hasmenu")) {
          const third_parent =
            last_parent.parentElement.parentElement.parentElement;
          if (third_parent.classList.contains("pcoded-hasmenu")) {
            third_parent.classList.add("pcoded-trigger");
          }
          last_parent.classList.add("pcoded-trigger");
          last_parent.classList.add("active");
        }
      }
      if (
        document
          .querySelector("app-navigation.pcoded-navbar")
          .classList.contains("mob-open")
      ) {
        document
          .querySelector("app-navigation.pcoded-navbar")
          .classList.remove("mob-open");
      }
    } else {
      setTimeout(() => {
        const sections = document.querySelectorAll(".pcoded-hasmenu");
        for (let i = 0; i < sections.length; i++) {
          sections[i].classList.remove("active");
          sections[i].classList.remove("pcoded-trigger");
        }

        let current_url = this.location.path();
        if (this.location["_baseHref"]) {
          current_url = this.location["_baseHref"] + this.location.path();
        }
        const link = "a.nav-link[ href='" + current_url + "' ]";
        const ele = document.querySelector(link);
        if (ele !== null && ele !== undefined) {
          const parent = ele.parentElement;
          const up_parent = parent.parentElement.parentElement;
          const last_parent = up_parent.parentElement;
          if (parent.classList.contains("pcoded-hasmenu")) {
            parent.classList.add("active");
          } else if (up_parent.classList.contains("pcoded-hasmenu")) {
            up_parent.classList.add("active");
          } else if (last_parent.classList.contains("pcoded-hasmenu")) {
            last_parent.classList.add("active");
          }
        }
      }, 500);
    }
  }
}
